import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Introduction from '@/views/Product/introduction'
import About from '@/views/About'
import Scheme from '@/views/Scheme'
import Partner from '@/views/Partner'


Vue.use(Router)

const routes = [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: '移领网络科技',
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: '移领网络科技-关于移领',
      }
    },
    {
      path: '/product-introduction',
      name: 'Introduction',
      component: Introduction,
      meta: {
        title: '移领网络科技-产品中心',
      }
    },
    {
      path: '/scheme',
      name: 'Scheme',
      component: Scheme,
      meta: {
        title: '移领网络科技-行业解决方案',
      }
    },
    {
      path: '/partner',
      name: 'Partner',
      component: Partner,
      meta: {
        title: '移领网络科技-合作伙伴',
      }
    },
  ]

const createRouter = () => new Router({
  mode: 'history', // require service support
  routes: routes,
})

const router = createRouter()

router.beforeEach(async (to,from,next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
  next()
});

export default router